<div class="app-container">

  <mat-toolbar color="primary">

    <span>Game Site</span>
    <span class="spacer"></span>

    <button mat-icon-button aria-label="menu icon" [matMenuTriggerFor]="menu">
      <mat-icon>menu</mat-icon>
    </button>

    <mat-menu #menu="matMenu">
      <a mat-menu-item routerLink='/home'>
        <mat-icon>home</mat-icon>
        <span>Home</span>
      </a>
      
      <a mat-menu-item routerLink='/checkers'>
        <mat-icon>fiber_manual_record</mat-icon>
        <span>Checkers</span>
      </a>
      
      <a mat-menu-item routerLink='/dots'>
        <mat-icon>fiber_manual_record</mat-icon>
        <span>Dots</span>
      </a>
      
    </mat-menu>

  </mat-toolbar>

  <router-outlet></router-outlet>
</div>
